/**
 * Created by caoyu on 2022/2/9.
 */

import Vue from 'vue'
import CKEditor from "./CKEditor.vue"

Vue.component("CKEditor", CKEditor);



// WEBPACK FOOTER //
// ./src/common/editor/editor.js